import React, { Component } from "react";
import { Field, formValueSelector } from "redux-form";
import { connect } from 'react-redux';
import FieldWrapper from './FieldWrapper.js';
import RenderField from './RenderField.js';
import CustomSpinner from './CustomSpinner.js';
import CustomAlert from './CustomAlert.js';
import apiService from "../services/apiService.js";
import validate from './Validations/syncValidationsCarAsPaymentPlateForm.js';

class CarAsPaymentPlate extends Component {
  state = {
    isLoading: false,
    requestError: false,
    errorValidationMessage: null,
    car_details: {},
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const { plate } = this.props;

    const validationErrors = validate({ plate });
    if (validationErrors && validationErrors.plate) {
      this.setState({ errorValidationMessage: validationErrors.plate });
      return;
    }else{
      this.setState({ errorValidationMessage: null });
    }

    this.setState({isLoading: true,})
    try{

        var data = {
            'plate': plate.toUpperCase().replace(/\s/g, "")
        };

        const response = await apiService.postResource('/subscribers/car_information_plate', data)

        const { pricing, used_car } = response.data.data;

        this.props.setCarDetails({
            car_price: pricing,
            car_model: used_car ? used_car.name : undefined,
          });

        this.props.handleChildComponent('quote')
    }catch (error) {
      this.setState({requestError: true});
    }finally{
      this.setState({isLoading: false});
    }
  }

  render() {

    const { requestError, errorValidationMessage } = this.state;

    const requestErrorObj = { title: '¡Lo sentimos!', message: 'Ocurrió un problema al obtener la información de las ofertas disponibles. Volvé a intentarlo dentro de unos minutos.' };

    return (
        <FieldWrapper>
          {(this.state.isLoading) && <CustomSpinner message='Estamos buscando tu auto ideal' />}
          {requestError && <CustomAlert bsStyle="info" title={requestErrorObj.title} message={requestErrorObj.message} />}
          {errorValidationMessage && <CustomAlert bsStyle="info" message={errorValidationMessage} />}
          <div className={this.state.errorValidationMessage ? "form-group has-error text-left" : "form-group text-left"}>
            <Field className="form-control" name="plate" autoComplete="off" component={RenderField} type="text" label="Patente" maxLength={7}/>
            <label>Ejemplo formato patente: AB123CD o AZN111</label>
          </div>
          <button onClick={this.handleSubmit} className="btn btn-warning btn-lg pd-button pd-form">Continuar</button>
        </FieldWrapper>
    );
  }
}
const selector = formValueSelector('CarAsPaymentForm')

CarAsPaymentPlate = connect(
  state => {
    const plate = selector(state, 'plate')
    return { plate }
  }
)(CarAsPaymentPlate)

export default CarAsPaymentPlate;


/** WEBPACK FOOTER **
 ** ./src/components/CarAsPaymentPlate.js
 **/